export default __webpack_public_path__ + "static/media/back.3b6135f5.svg";